export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function formatDateLabel(raw: string): string {
  const datePart = raw.split(" ")[0];
  const [year, month, day] = datePart.split("-");
  if (!year || !month || !day) return datePart;
  return `${year}年${Number(month)}月${Number(day)}日`;
}

export function shortDate(raw: string): string {
  const datePart = raw.split(" ")[0];
  const parts = datePart.split("-");
  if (parts.length < 3) return datePart;
  return `${parts[1]}/${parts[2]}`;
}